<template>
  <div v-if="hubspot" v-bind="$attrs" @click="handleClick">
    <ChatBubbleBottomCenterTextIcon class="main-mobile-footer-icon" aria-hidden="true" />
    <div class="main-mobile-footer-caption">{{ t('Help?') }}</div>
  </div>
</template>

<script setup lang="ts">
import { useLocale } from '@/plugins/i18n'

import { useHubspot } from '@/plugins/hubspot'

import { ChatBubbleBottomCenterTextIcon } from '@heroicons/vue/24/outline'

const { t } = useLocale('layouts.Main')

const hubspot = useHubspot()

const handleClick = () => {
  hubspot?.open()
}
</script>
